import React from "react";
import EditableTableComponent from "../../../Components/Table/EditableTable";

const Status = () => {
  const columns = [
    { header: "Add Text", accessor: "bo", width: "100px" },
    { header: "Add Text", accessor: "Target" },
    { header: "Add Text", accessor: "ytdTarget" },
    { header: "Add Text", accessor: "ytdActual" },
    { header: "Add Text", accessor: "mtdTarget" },
    { header: "Add Text", accessor: "mtdActual" },
    { header: "Add Text", accessor: "closing" },
  ];

  const initialData = [
    {
      bo: "Add Text",
      Target: "Add Text",
      ytdTarget: "Add Text",
      ytdActual: "Add Text",
      mtdTarget: "Add Text",
      mtdActual: "Add Text",
      closing: "Add Text",
    },
    {
      bo: "Add Text",
      Target: "Add Text",
      ytdTarget: "Add Text",
      ytdActual: "Add Text",
      mtdTarget: "Add Text",
      mtdActual: "Add Text",
      closing: "Add Text",
    },
  ];

  return (
    <div>
      <EditableTableComponent
        columns={columns}
        initialData={initialData}
        heading={"Status"}
      />
    </div>
  );
};

export default Status;
